// Client-side notification test that bypasses Cloud Functions deployment issues
import { createLogger } from './logger';

const logger = createLogger('TestClientSideNotifications');

/**
 * Test client-side notification capabilities
 */
export const testClientSideNotifications = async () => {
  try {
    // Check if notifications are supported
    if (!('Notification' in window)) {
      return {
        success: false,
        message: 'Notifications are not supported in this browser',
        supported: false
      };
    }

    // Check permission status
    const permission = Notification.permission;
    logger.info('Notification permission:', permission);

    if (permission === 'denied') {
      return {
        success: false,
        message: 'Notifications are blocked by the user',
        permission: 'denied'
      };
    }

    if (permission === 'default') {
      return {
        success: false,
        message: 'Notification permission not granted yet',
        permission: 'default',
        needsPermission: true
      };
    }

    // Test creating a notification
    const testNotification = new Notification('Test Notification', {
      body: 'This is a test notification from PackMyCart',
      icon: '/logo192.png',
      badge: '/logo192.png',
      tag: 'test-notification',
      requireInteraction: false,
      silent: false
    });

    // Auto-close after 3 seconds
    setTimeout(() => {
      testNotification.close();
    }, 3000);

    return {
      success: true,
      message: 'Client-side notifications are working!',
      permission: 'granted',
      notification: 'Test notification sent successfully'
    };

  } catch (error) {
    logger.error('Error testing client-side notifications:', error);
    return {
      success: false,
      message: 'Error testing notifications: ' + error.message,
      error: error.message
    };
  }
};

/**
 * Request notification permission
 */
export const requestNotificationPermission = async () => {
  try {
    if (!('Notification' in window)) {
      return {
        success: false,
        message: 'Notifications are not supported in this browser'
      };
    }

    const permission = await Notification.requestPermission();
    logger.info('Permission request result:', permission);

    return {
      success: permission === 'granted',
      message: permission === 'granted' ? 'Permission granted!' : 'Permission denied',
      permission
    };

  } catch (error) {
    logger.error('Error requesting notification permission:', error);
    return {
      success: false,
      message: 'Error requesting permission: ' + error.message,
      error: error.message
    };
  }
};

/**
 * Test FCM token registration (client-side only)
 */
export const testFCMTokenRegistration = async (fcmService) => {
  try {
    if (!fcmService) {
      return {
        success: false,
        message: 'FCM service not available'
      };
    }

    const token = await fcmService.requestPermissionAndGetToken();
    
    if (token) {
      return {
        success: true,
        message: 'FCM token registered successfully',
        token: token.substring(0, 20) + '...' // Show first 20 chars for security
      };
    } else {
      return {
        success: false,
        message: 'Failed to get FCM token'
      };
    }

  } catch (error) {
    logger.error('Error testing FCM token registration:', error);
    return {
      success: false,
      message: 'Error registering FCM token: ' + error.message,
      error: error.message
    };
  }
};






